import React from 'react';
import { Card, Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import '../index.css';

class DataAnalysisCard extends React.Component {
	render() {
		const { image, link, label, offset, className } = this.props;
		const { Text } = Typography;

		return (
			<Col>
				<Link to={link}>
					<Card className="menu-card">
						<Row>
							<Col span={24}>
								<img src={image} alt="icon" />
							</Col>
						</Row>
						<Row>
							<Col
								span={24}
								style={{
									marginTop: '10px',
									fontWeight: 'bold',
									fontSize: '15px',
								}}
								className={className}
							>
								<Text className="font-md">{label}</Text>
							</Col>
						</Row>
					</Card>
				</Link>
			</Col>
		);
	}
}

DataAnalysisCard.propTypes = {
	image: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	offset: PropTypes.number,
	className: PropTypes.string.isRequired,
};

DataAnalysisCard.defaultProps = {
	offset: null,
};

export default DataAnalysisCard;
